import {
  Staff,
  StaffBasic,
  StaffLight,
  StaffMinimal,
  StaffPosition
} from '../../lib/types/models/staff/staff'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type StaffVersionMap = {
  FULL: Staff
  LIGHT: StaffLight
  BASIC: StaffBasic
  MINIMAL: StaffMinimal
  POSITION: StaffPosition
}
export function getStaff<T extends keyof StaffVersionMap = 'FULL'>(
  id: number,
  version: T = 'FULL' as T
): Promise<StaffVersionMap[T]> {
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.staffs.get.url, { id }), { version }))
    .get<StaffVersionMap[T]>()
}
